<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Nunito">


<template>
  <ion-page>
    <ion-content :fullscreen="true" class="loginscreen">
      <div class="logobar">
      nightingale
      </div>
  

      <ion-row>
        <ion-col class="splash"  sizeXs="12" sizeMd="6" sizeLg="6">
          <img class="ss" src="./ss.png"/>
          <div class="overlay">
            <img class="youtubeIcon imgIcon" src="./icons8-play-button-fluent.svg"/>
            <img class="plusIcon imgIcon" src="./icons8-plus.svg"/>
            <img class="spotifyIcon imgIcon" src="./icons8-spotify-fluent.svg"/>
          </div>
        </ion-col>

        <ion-col class="login" sizeXs="12" sizeMd="6" sizeLg="6">
          <div class="loginCenter">
            <h1><b>Rediscover music.</b></h1>
            <h3>Find music events near you, discover new playlists 
            or port your Youtube playlists over to Spotify!</h3>
            <br>
            <ion-button  item-right color="success" @click="login">Login with Spotify</ion-button>

          </div>
        </ion-col>
      </ion-row>

    </ion-content>
  </ion-page> 
</template>

<script lang="ts">
  import { IonPage  } from '@ionic/vue';
  import { useRouter } from 'vue-router';
  import { defineComponent } from 'vue';
  

  export default defineComponent({
    name: 'Login',
    components: {IonPage },
    created: function(){
      this.checkLogin();
    },
    setup() { 
      const router = useRouter();
      const spotifyConfig = {
        clientId: '5da7f93846a048c2834a174fe06e5bb9',
        redirectUri: 'https://nightingale-1d29b.web.app/app',
      };
     

      return {spotifyConfig, router}

    },
     computed: {
        // declare the type returned by your function/computed/method
        url(): string {
            return this.getLoginURL(['user-read-email playlist-modify-public playlist-modify-private']);
        }
    },
    methods:{
    redirect(){
        this.router.push('/music/recommended');
        
    },
    redirectFalse(){
        this.router.push('/app/');
    },
    login(){
      localStorage.clear();
      return new Promise((resolve, reject) => {
          window.addEventListener('message', event => {
            
            const hash = JSON.parse(event.data);
            // alert("PO")
            if (hash.type == 'access_token') {
              resolve(hash.access_token);
            }else{
              reject()
              this.router.push('/app/');
            }
          }, false);
  
          // Show spotify auth popup
          window.open(this.url,"_self");
          this.checkLogin();
        });
    },
    getLoginURL(scopes: [string]){
        return 'https://accounts.spotify.com/authorize?client_id=' + this.spotifyConfig.clientId +
            '&redirect_uri=' + encodeURIComponent(this.spotifyConfig.redirectUri) +
            '&scope=' + encodeURIComponent(scopes.join(' ')) +
            '&response_type=token&show_dialog=true&scope=playlist-read-private';
    },
     async getUserData(accessToken: string) {
      const res = await fetch( `https://api.spotify.com/v1/me`, { 'headers': {'Authorization': 'Bearer ' + accessToken }});
      const data = (await res.json());

      localStorage.setItem('userID', data.id);
      localStorage.setItem('userID', encodeURI(localStorage.getItem('userID') || ''));
      window.dispatchEvent(new CustomEvent('userID-Added', {
        detail: {
          storage: localStorage.getItem('userID')
        }
      }));

      let token=""
      this.postData({
                "data": {
                    "email":data.email,
                    "user_id": data.display_name,
                    "spotifyUrl": data.external_urls.spotify
                }
            }).then(data => {
            console.log(data.result.token); // JSON data parsed by `data.json()` call
            token=data.result.token
            return null
        }).then(data=>{
            // console.log("THIS IS DATA"+token)
            const signInResult= this.loginTheUserWithToken(token)
            // console.log(signInResult)
            return signInResult
        })

      // const dataTwo = await this.postData(data);
      // await this.loginTheUserWithToken(dataTwo);
    },

   async postData(data: Record<string, any>) {
            const url="https://us-central1-nightingale-1d29b.cloudfunctions.net/signUp";
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(data) // body data type must match "Content-Type" header
            });
            return response.json(); // parses JSON response into native JavaScript objects
    },
   async loginTheUserWithToken(data: string) {
    //  alert(data)
            const url="https://identitytoolkit.googleapis.com/v1/accounts:signInWithCustomToken?key=AIzaSyAhMDes-KpPanP6fUHSreiP9FDAp7V15D8";
            return await fetch(url, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                redirect: 'follow', // manual, *follow, error
                referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify({'token':`${data}`, 'returnSecureToken':true}) // body data type must match "Content-Type" header
            }).then(res =>res.json())

    },
   

    

    checkLogin(){
      if(localStorage.getItem('accesstoken') !== null){
        this.router.push('/music/recommended');
        return;
      }   
      const queryString = window.location.hash;
      const token: Array<string>[] = [];    
      queryString.replace(/^#\/?/, '').split('&').forEach(keyval => {
        const splitIndex = keyval.indexOf('=');
        if (splitIndex == -1) {
          return;
        }
        const key: string = keyval.substring(0, splitIndex);
        const val: string = decodeURIComponent(keyval.substring(splitIndex + 1));
        token.push([key,val])
        
      });
      if(token.length == 3){
        if(token[0][0] == "access_token" && token[0][1] != null){
          //alert(token[0][1]) //add token function
          localStorage.setItem('accesstoken', token[0][1])
          this.getUserData(token[0][1])
          //console.log(token[0][1])
          this.redirect()
        }
        
      }
    },
    tokenReturn(token: string){
      return token
    },
    updateFirebase(data: string) {
        console.log(data)
        // return fetch(
        //   'https://api.spotify.com/v1/me',
        //   { 'headers': {'Authorization': 'Bearer ' + accessToken } }
        // );
        return "OK"
    },

    },

    })
</script>

<style>

ion-row{
  color:white;
height: -moz-calc(100% - 60px); /* Firefox */
 height: -webkit-calc(100% - 60px); /* Chrome, Safari */
 height: calc(100% - 60px); /* IE9+ and future browsers */
}

.ss{
    width:75%;
    border-radius: 25px;
    border: solid 20px;
}

.imgIcon{
  height: 75px;
}

.plusIcon{
  height:25px;
  margin:0px 15px 25px 15px;
}
.loginCenter{
  text-align:center;
  padding-left:10%;
  padding-right:10%;
}

.overlay{
  float:left;
  position: absolute;
}

h1{
  font-size: 60px;
}
h3{
  color: #e7e7e7;

}


.login{
  align-items: center;
  display: flex;
  justify-content: center;
  padding:20px;
      padding-top:12%;
      padding-bottom:12%;

}
.splash{
  color:white;
  display: flex;
  justify-content: center;
  align-items: center;
      padding-top:12%;
      padding-bottom:12%;
}

.loginscreen {
    --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1920' height='1080' preserveAspectRatio='none' viewBox='0 0 1920 1080'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1016%26quot%3b)' fill='none'%3e%3crect width='1920' height='1080' x='0' y='0' fill='rgba(20%2c 21%2c 21%2c 1)'%3e%3c/rect%3e%3cpath d='M352.94 1161.16C556.72 1100.66 606.95 533.95 914.41 522.6 1221.87 511.25 1195.14 657.6 1475.87 657.6 1756.61 657.6 1892.98 523.54 2037.34 522.6' stroke='rgba(253%2c 45%2c 85%2c 0.5)' stroke-width='4'%3e%3c/path%3e%3cpath d='M362.13 1160.2C523.53 1140.1 616.57 775.94 885.83 774.2 1155.08 772.46 1147.67 909.2 1409.52 909.2 1671.37 909.2 1798.02 775.28 1933.22 774.2' stroke='rgba(253%2c 45%2c 85%2c 0.5)' stroke-width='4'%3e%3c/path%3e%3cpath d='M683.26 1253.07C885.12 1167.12 793.38 541.93 1190.67 537.04 1587.97 532.15 1943.66 794.2 2205.5 796.24' stroke='rgba(253%2c 45%2c 85%2c 0.5)' stroke-width='4'%3e%3c/path%3e%3cpath d='M222.84 1143.6C486.38 1010.84 474.72 186.61 855.28 146.98 1235.84 107.35 1171.5 281.98 1487.73 281.98 1803.95 281.98 1958.5 147.73 2120.17 146.98' stroke='rgba(253%2c 45%2c 85%2c 0.5)' stroke-width='4'%3e%3c/path%3e%3cpath d='M1288.07 1250.71C1462.9 1202.01 1444.6 787.25 1776.93 714.06 2109.26 640.87 2108.35 329.63 2265.79 303.66' stroke='rgba(253%2c 45%2c 85%2c 0.5)' stroke-width='4'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1016'%3e%3crect width='1920' height='1080' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e");    background-repeat: no-repeat;
    background-position:right top;
  }


</style>



